
const CalculatedDiscountApplication = {
  "name": "CalculatedDiscountApplication",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "allocationMethod": "DiscountApplicationAllocationMethod",
    "appliedTo": "DiscountApplicationLevel",
    "description": "String",
    "id": "ID",
    "targetSelection": "DiscountApplicationTargetSelection",
    "targetType": "DiscountApplicationTargetType",
    "value": "PricingValue"
  },
  "possibleTypes": ["CalculatedAutomaticDiscountApplication", "CalculatedDiscountCodeApplication", "CalculatedManualDiscountApplication", "CalculatedScriptDiscountApplication"]
};
export default CalculatedDiscountApplication;